// Category ids + their public (English) URL slug — split out from lib/ressources.ts
// on purpose: this file has zero dependencies (no `node:fs`) so client components
// (nav, post cards) can import it directly without dragging server-only code into
// the browser bundle.
export const CATEGORIES = ["guides", "productivite", "actualites", "temoignages"] as const;
export type Category = (typeof CATEGORIES)[number];

// Public slug per category, decoupled from the internal ids above so
// content/ressources/<categorie>/ on disk (and authoring conventions in
// README.md/PROMPT-SYSTEME-REDACTION.md/scripts/*) stay French, while the
// route segment is translated — one English slug shared by both languages,
// FR at the base path, EN at `/en`, same as /legal-notice, /terms-of-sale etc.
export const CATEGORY_SLUGS: Record<Category, string> = {
  guides: "guides",
  productivite: "productivity",
  actualites: "news",
  temoignages: "testimonials",
};

const SLUG_TO_CATEGORY = Object.fromEntries(
  CATEGORIES.map((category) => [CATEGORY_SLUGS[category], category])
) as Record<string, Category>;

export function categoryFromSlug(slug: string): Category | null {
  return SLUG_TO_CATEGORY[slug] ?? null;
}

export function categoryToSlug(category: Category): string {
  return CATEGORY_SLUGS[category];
}
